import axios from "axios";

export default {
    async exportar(params = {}) {
        return axios.get("/api/admin/aforos/exportar", {
            responseType: "blob",
            params,
        });
    },
}
